export const CONTROL_TYPES_WITH_COUNTER = ['text', 'textarea'];
